<script>
    import { shipmentStore } from "../../stores/store.js";
    import { slide } from "svelte/transition";
    export let getData;
</script>

<div class="search-area">
    {#if $shipmentStore.search.isExpanded}
        <section class="search-panel">
            <div class="search-grid">
                <div class="field date-range-field">
                    <label>납기일</label>
                    <div class="date-range-inputs">
                        <input
                            type="date"
                            bind:value={$shipmentStore.search.startDate}
                        />
                        <span>~</span>
                        <input
                            type="date"
                            bind:value={$shipmentStore.search.endDate}
                        />
                    </div>
                </div>
                <div class="field">
                    <label>납품처</label>
                    <input
                        type="text"
                        placeholder="납품처 입력"
                        bind:value={$shipmentStore.search.customer}
                    />
                </div>
                <div class="field">
                    <label>수주번호</label>
                    <input
                        type="text"
                        placeholder="수주번호 입력"
                        bind:value={$shipmentStore.search.orderNo}
                    />
                </div>
                <div class="field checkbox-field-container">
                    <label class="invisible-label">&nbsp;</label>
                    <div class="checkbox-group">
                        <label class="checkbox-label" class:checked={$shipmentStore.search.includeComplete}>
                            <input
                                type="checkbox"
                                bind:checked={$shipmentStore.search.includeComplete}
                            />
                            <span>출하완료포함</span>
                        </label>
                        <label class="checkbox-label" class:checked={$shipmentStore.search.includeClose}>
                            <input
                                type="checkbox"
                                bind:checked={$shipmentStore.search.includeClose}
                            />
                            <span>수주마감포함</span>
                        </label>
                    </div>
                </div>
            </div>
            <button class="main-btn" on:click={getData}>데이터 조회하기</button>
        </section>
    {/if}
    <div
        class="toggle-bar"
        on:click={() =>
            shipmentStore.update((s) => ({
                ...s,
                search: {
                    ...s.search,
                    isExpanded: !s.search.isExpanded,
                },
            }))}
    >
        <div class="toggle-content">
            <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
            >
                <path
                    d={$shipmentStore.search.isExpanded
                        ? "m18 15-6-6-6 6"
                        : "m6 9 6 6 6-6"}
                />
            </svg>
            <span>
                {$shipmentStore.search.isExpanded
                    ? "조회 조건 접기"
                    : "조회 조건 펼쳐서 다시 검색하기"}
            </span>
        </div>
    </div>
</div>

<style>
    .search-area {
        flex-shrink: 0;
        background: white;
        border-bottom: 1px solid #e2e8f0;
        padding: 15px 15px 0 15px;
    }
    .search-panel {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 10px;
    }
    .search-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 10px;
    }
    .field > label {
        display: block;
        font-size: 0.7rem;
        font-weight: 800;
        color: #64748b;
        margin-bottom: 4px;
    }
    .date-range-inputs {
        display: flex;
        align-items: center;
        gap: 3px;
    }
    .date-range-inputs input {
        flex: 1;
        min-width: 0;
        padding: 0 4px;
        font-size: 0.8rem;
    }
    .date-range-inputs span {
        font-size: 0.75rem;
        color: #94a3b8;
    }
    .field input:not([type="checkbox"]) {
        width: 100%;
        height: 35px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        padding: 0 8px;
        font-size: 0.85rem;
        box-sizing: border-box;
    }
    .field input:focus {
        outline: none;
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
    }
    .main-btn {
        width: 100%;
        height: 40px;
        background: #3b82f6;
        color: white;
        border: none;
        border-radius: 4px;
        font-weight: 800;
        margin-top: 10px;
        cursor: pointer;
    }
    .toggle-bar {
        padding: 8px 0;
        background: #ffffff;
        cursor: pointer;
        display: flex;
        justify-content: center;
        border-top: 1px solid #f1f5f9;
    }
    .toggle-content {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #3b82f6;
        font-size: 0.85rem;
        font-weight: 800;
    }
    .invisible-label {
        visibility: hidden;
    }
    .checkbox-group {
        display: flex;
        align-items: center;
        width: 100%;
        height: 35px;
        border: 1.5px solid #e2e8f0;
        border-radius: 4px;
        background: #ffffff;
        box-sizing: border-box;
        overflow: hidden;
    }
    .checkbox-label {
        display: flex !important;
        align-items: center;
        justify-content: center;
        font-size: 0.82rem;
        font-weight: 700;
        color: #475569;
        cursor: pointer;
        user-select: none;
        flex: 1;
        height: 100%;
        margin: 0 !important;
        padding: 0 4px;
        background: #ffffff;
        transition: all 0.2s ease;
        position: relative;
    }
    .checkbox-label span {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }
    .checkbox-label:not(:last-child) {
        border-right: 1.5px solid #e2e8f0;
    }
    .checkbox-label:not(.checked):hover {
        background: #f8fafc;
        color: #1e293b;
    }
    .checkbox-label.checked {
        background: #3b82f6;
        color: #ffffff;
    }
    .checkbox-label input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    @media (max-width: 768px) {
        .search-grid {
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>
